import { getSettingsGenericError } from './chunk-TDNRUBPG.mjs';
import { i18n_config_default } from './chunk-EJ2TIXJU.mjs';
import { DateTime } from 'luxon';
import * as yup from 'yup';

var customerSchema = yup.object({
  firstName: yup.string().trim().required(
    JSON.stringify(
      getSettingsGenericError({
        key: "firstName",
        id: "firstName",
        message: i18n_config_default.t("customersScreen.errors.firstName"),
        section: "basic" /* BASIC */
      })
    )
  ),
  lastName: yup.string().trim().required(
    JSON.stringify(
      getSettingsGenericError({
        key: "lastName",
        id: "lastName",
        message: i18n_config_default.t("customersScreen.errors.lastName"),
        section: "basic" /* BASIC */
      })
    )
  ),
  phoneNumber: yup.string().trim().required(
    JSON.stringify(
      getSettingsGenericError({
        key: "phoneNumber",
        id: "phoneNumber",
        message: i18n_config_default.t("customersScreen.errors.phoneNumber.empty"),
        section: "basic" /* BASIC */
      })
    )
  ).test("customer-phone-validation", "", function(phoneNumber) {
    if (!phoneNumber || (phoneNumber == null ? void 0 : phoneNumber.length) !== 10) {
      return this.createError({
        message: JSON.stringify(
          getSettingsGenericError({
            key: "phoneNumber",
            id: "phoneNumber",
            message: i18n_config_default.t(
              `customersScreen.errors.phoneNumber.${!phoneNumber ? "empty" : "invalid"}`
            ),
            section: "basic" /* BASIC */
          })
        )
      });
    }
    return true;
  }),
  dateOfBirth: yup.string().test("date-of-birth-validation", "", function(dateOfBirth) {
    if (!dateOfBirth) {
      return true;
    }
    const isValid = DateTime.fromFormat(dateOfBirth, "MM/dd/yyyy").isValid;
    if (!isValid) {
      return this.createError({
        message: JSON.stringify(
          getSettingsGenericError({
            key: "dateOfBirth",
            id: "dateOfBirth",
            message: i18n_config_default.t("customersScreen.errors.dateOfBirth"),
            section: "basic" /* BASIC */
          })
        )
      });
    }
    return true;
  })
});

export { customerSchema };
